module.exports = __webpack_public_path__ + "static/gudkov-176f22a2527367c9097a799fb0c61bd0.png";